import React from "react";
import { Calendar, Clock, Monitor } from "../AdminIcons";
const SessionDetail = ({ icon: Icon, value }) => (
  <div className="flex items-center gap-2.5 p-2.5 text-[22px] leading-[26px] text-[#484848]">
    <Icon />
    <span>{value}</span>
  </div>
);

const StudentUpcomingSessions = ({
  courseName = "Mental Maths",
  module = "Intro to Maths",
  liveSession = "Session 1",
  sessionDate = "May 28, 2025",
  sessionTime = "10:00am - 11:30 am",
  instructor = "David Miller",
  onViewAllSessions,
}) => {
  return (
    <section className="rounded-xl border border-[#60555557] bg-white px-6 py-6 sm:pl-9 sm:pr-7">
      <h3 className="text-xl font-medium leading-[23px] text-black">Upcoming Live Sessions</h3>

      <div className="mt-2 grid grid-cols-2 gap-5">
        <div className="space-y-5 pl-12">
          <div>
            <p className="text-[#484848] text-[22px] leading-[26px]">Course Name</p>
            <p className="mt-[1px]  text-[#2D2D2D] text-xl leading-[23px]">{courseName}</p>
          </div>
          <div>
            <p className="text-[#484848] text-[22px] leading-[26px]">Module</p>
            <p className="mt-[1px]  text-[#2D2D2D] text-xl leading-[23px]">{module}</p>
          </div>
          <div>
            <p className=" text-[#484848] text-[22px] leading-[26px]">Live Session</p>
            <p className="mt-[1px]  text-[#2D2D2D] text-xl leading-[23px]">{liveSession}</p>
          </div>
        </div>

        <div className="space-y-1 ml-auto">
          <SessionDetail icon={Calendar} value={sessionDate} />
          <SessionDetail icon={Clock} value={sessionTime} />
          <SessionDetail icon={Monitor} value={`Instructor: ${instructor}`} />
        </div>
      </div>
     
     <div className=" w-full flex justify-center">
      <button
        type="button"
        className="mt-5 max-w-[459px] w-full  rounded-lg border border-[#923D8C] bg-[#EDEDED] py-[5px] text-lg leading-[21px] font-medium text-[#923D8C]"
        onClick={onViewAllSessions}
      >
        View All Sessions
      </button>
      </div>
    </section>
  );
};

export default StudentUpcomingSessions;
